import { render } from "./DiabetologiePage.vue?vue&type=template&id=5e6da972"
import script from "./DiabetologiePage.vue?vue&type=script&lang=js"
export * from "./DiabetologiePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__